import { FORCE_VARIANT_PARAM } from 'constants/personalize';

import { getExperienceAndVariantFromAlias } from 'utils/contentstack/personalize';

import { PersonalizeCSRFetchService } from './csrFetchService';

export class PersonalizeService {
  static async fetchPersonalizeDataCSR(sdk, uid, search) {
    const rawAliases = sdk.getVariantAliases();
    if (!rawAliases || rawAliases.length === 0) return null;

    // Apply ?variant= override per alias if present
    const aliases = rawAliases.map((alias) => PersonalizeService.getForcedVariant(alias, search) || alias);

    const entry = await PersonalizeCSRFetchService.fetchPersonalizedPage(uid, aliases);
    if (!entry) return null;

    // publish_details.variants is an object keyed by variant UID, each with an `.alias` field.
    // Extract aliases that actually applied to this entry.
    const variantsMap = entry.publish_details?.variants;
    const appliedAliases = Object.values(variantsMap)
      .map((v) => v.alias)
      .filter(Boolean);

    if (!appliedAliases.length) return null;

    // `aliases` (plural) distinguishes CSR response from legacy `{ alias, data }`
    return { aliases: appliedAliases, data: entry };
  }

  // Supports per-experience (?variant=expUid_2&variant=expUid2_1) and legacy (?variant=2).
  static getForcedVariant(activeAlias, search) {
    if (!activeAlias) return;

    const params = new URLSearchParams(search || '');
    const forcedParams = params.getAll(FORCE_VARIANT_PARAM);
    if (!forcedParams.length) return;

    const { experienceShortUid } = getExperienceAndVariantFromAlias(activeAlias);
    const aliasWithoutVariant = activeAlias.replace(/(\d+)$/, '');

    const perExperience = forcedParams.find((p) => p.startsWith(`${experienceShortUid}_`));
    if (perExperience) return `${aliasWithoutVariant}${perExperience.slice(perExperience.lastIndexOf('_') + 1)}`;

    // Legacy: single ?variant=2 with no underscore
    if (forcedParams.length === 1 && !forcedParams[0].includes('_')) {
      return `${aliasWithoutVariant}${forcedParams[0]}`;
    }
  }
}
